import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cforloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>for loop Statement in c tutorial For Beginners</title>
 <meta name="description" content="for loop in c tutorial for beginners.The body of the loop must be executed until the given condition is false, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c for loop,c for loop programs,programming in c for loop,c for loop syntax,c foreach loop,c for loop break,c for loop continue,c for loop increment,c for loop without braces" />
 <link rel="canonical" href="https://www.codeexampler.com/c-for-loop" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">For loop Statement in c</h1>
    <div className="first">
        <a href="/c-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">For loop in c:
</h2>

<p className="mt-3 para">1, The body of the loop Executes until the given condition is false<br/>
2, In the for loop, a semicolon uses <br/>
3, This for loop is using to repeat a particular piece of code for a fixed no of times<br/>
</p>


<h2 className="headings">For loop C Syntax</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
  <pre style={{ maxHeight: '500vh' }}>
    <code>
      {"\n"}
        <span className="qwerty-6">for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-3"> intialization</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-10">condition</span>
      <span className="qwerty-4">;</span>
      <span className="qwerty-8"> incrementation</span>
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-10">  statement</span>
      {"\n"}{"\n"}
    </code>
  </pre>
</div> 


<h2 className="headings">Q-Write a Program to print a number from 1 to 10 in for-loop?</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
  <pre style={{ maxHeight: '500vh' }}>
    <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
  </pre>
</div> 
<h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-10">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-10">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-10">6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-10">8</span>                   
                  {"\n"}         
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-10">10</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 


<h2 className="mt-4 mh2">Important:</h2>
<p className="mt-4 para">When you print a no into a different column so use (\n).
</p>


<h2 className="headings">Q-Write a Program loop starts from 1 to 10 but print from 2 to 11?</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
  <pre style={{ maxHeight: '500vh' }}>
    <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">)</span>
        <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-5">   i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                       
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
  </pre>
</div> 
<h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}            
                  <span className="qwerty-1">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-1">8</span>                   
                  {"\n"}         
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-1">10</span>                   
                  {"\n"}  
                  <span className="qwerty-1">11</span>                   
                  {"\n"}           
                  {"\n"}         
                </code>
                </pre>
                </div> 

<h2 className="headings">Q-Write a Program to print a name when a program is complete in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
               <span className="qwerty-7">#include </span>
               <span className="qwerty-4">&#60;</span>
               <span className="qwerty-10">stdio.h</span>
               <span className="qwerty-4">&#62; </span>
                              {"\n"} 
              <span className="qwerty-3">int </span>
              <span className="qwerty-2">main</span>
              <span className="qwerty-4"> ()</span>            
              {"\n"}
              <span className="qwerty-4" >&#123; </span>            
              {"\n"}
              <span className="qwerty-3"> int</span>
              <span className="qwerty-5"> i</span>                     
              <span className="qwerty-4">;</span>                     
              {"\n"}
              <span className="qwerty-6"> for</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">i</span>
              <span className="qwerty-4">=</span>
              <span className="qwerty-1">1</span>
              <span className="qwerty-4">; </span>
              <span className="qwerty-5">i</span>
              <span className="qwerty">&#60;=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-4">;</span>
              <span className="qwerty-5"> i</span>
              <span className="qwerty">++</span>
              <span className="qwerty-4">;</span>                                   
            <span className="qwerty-4">)</span>
              {"\n"} 
              <span className="qwerty-4"> &#123;</span>
              {"\n"}
              <span className="qwerty-8">  printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-3">%d</span>
              <span className="qwerty-10"> \n</span>
              <span className="qwerty-4">",</span>
              <span className="qwerty-5"> i</span>
              <span className="qwerty-4">);</span>
              {"\n"}
                    <span className="qwerty-4"> &#125;</span>
              {"\n"}
              <span className="qwerty-8">  printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-10">Code Exampler </span>
              <span className="qwerty-4">"</span>
              <span className="qwerty-4">);</span>
              {"\n"}
              
              <span className="qwerty-7"> return</span>
              <span className="qwerty-3"> 0</span>
              <span className="qwerty-4">; </span>
                  {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div> 
      <h4 className='headings'>Output :</h4>
              <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
                <pre style={{maxHeight:"100vh"}}>
                      <code >                  
                      {"\n"}      
                        <span className="qwerty-1">1</span>                   
                        {"\n"}         
                        <span className="qwerty-1">2</span>                   
                        {"\n"}         
                        <span className="qwerty-1">3</span>                   
                        {"\n"}         
                        <span className="qwerty-1">4</span>                   
                        {"\n"}         
                        <span className="qwerty-1">5</span>                   
                        {"\n"}         
                        <span className="qwerty-1">6</span>                   
                        {"\n"}         
                        <span className="qwerty-1">7</span>                   
                        {"\n"}         
                        <span className="qwerty-1">8</span>                   
                        {"\n"}         
                        <span className="qwerty-1">9</span>                   
                        {"\n"}         
                        <span className="qwerty-1">10</span>                   
                        {"\n"}         
                        <span className="qwerty-3">Code Exampler</span>                   
                        {"\n"}         
                        {"\n"}         
                      </code>
                      </pre>
                      </div> 


<h2 className="headings">Q-Write a Program to print a name again in for loop?</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
  <pre style={{ maxHeight: '500vh' }}>
    <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Ram-Ram \n</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
  </pre>
</div> 
<h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">2 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">7 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">8 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">9 Ram-Ram</span>                   
                  {"\n"}         
                  <span className="qwerty-1">10 Ram-Ram</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 




<h2 className="headings">Q-Write a Program to combine ano and name in for loop?</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
  <pre style={{ maxHeight: '500vh' }}>
    <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Hello Ram</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
  </pre>
</div> 
<h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">2</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">4</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">8</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Hello Ram </span>                   
                  <span className="qwerty-1">10</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 




<h2 className="headings">Q-Write a Program to range stated from 2 and finish on 8 in for-loop?</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
  <pre style={{ maxHeight: '500vh' }}>
    <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">,</span>                     
        <span className="qwerty-5"> first</span>                     
        <span className="qwerty-4">,</span>                     
        <span className="qwerty-5"> last</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter First no \n</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-6">   scanf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-3">",</span>
                <span className="qwerty-1"> &amp;</span>
                <span className="qwerty-10">first </span>
                <span className="qwerty-3">);</span>
            {"\n"}
       
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter Last no \n</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-6">   scanf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-3">",</span>
                <span className="qwerty-1"> &amp;</span>
                <span className="qwerty-10">last </span>
                <span className="qwerty-3">);</span>
            {"\n"}
       
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-5">first</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">last</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}        
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Number is</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
  </pre>
</div> 
<h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-10">Enter First No</span>                   
                  {"\n"}         
                  <span className="qwerty-3">2</span>                   
                  {"\n"}         
                  {"\n"}         
                  <span className="qwerty-10">Enter Last no</span>                   
                  {"\n"}         
                  {"\n"}         
                  <span className="qwerty-3">8</span>                   
                  {"\n"}         
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 2</span>                   
                  {"\n"}
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 3</span>                   
                  {"\n"} 
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 7</span>                   
                  {"\n"}         
                  <span className="qwerty-1">Number is</span>                   
                  <span className="qwerty-1"> 8</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div>

<h2 className="headings">Q-Write a Program to Fibonacci Series in for-loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
               <span className="qwerty-7">#include </span>
               <span className="qwerty-4">&#60;</span>
               <span className="qwerty-10">stdio.h</span>
               <span className="qwerty-4">&#62; </span>
                {"\n"} 
              <span className="qwerty-3">int </span>
              <span className="qwerty-2">main</span>
              <span className="qwerty-4"> ()</span>            
              {"\n"}
              <span className="qwerty-4" >&#123; </span>            
              {"\n"}
              <span className="qwerty-3"> int</span>
              <span className="qwerty-5"> i</span>                     
              <span className="qwerty-4">,</span>                     
              <span className="qwerty-5"> a</span>                     
              <span className="qwerty-4">=</span>                     
              <span className="qwerty-1">0</span>                     
              <span className="qwerty-4">,</span>                     
              <span className="qwerty-5"> b</span>                     
              <span className="qwerty-4">=</span>                     
              <span className="qwerty-1">1</span>                     
              <span className="qwerty-4">,</span>                     
              <span className="qwerty-5">c</span>                     
              <span className="qwerty-4">;</span>                     
              {"\n"}
              <span className="qwerty-8"> printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-10">Fibonacci Series of first 10 number\n</span>
              <span className="qwerty-4">"</span>
              <span className="qwerty-4">);</span>
              {"\n"}
              <span className="qwerty-6"> for</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">i</span>
              <span className="qwerty-4">=</span>
              <span className="qwerty-1">0</span>
              <span className="qwerty-4">;</span>
              <span className="qwerty-5">i</span>
              <span className="qwerty">&#60;=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-4">;</span>
              <span className="qwerty-5">i</span>
              <span className="qwerty">++</span>
              <span className="qwerty-4">)</span>
              {"\n"} 
              <span className="qwerty-4"> &#123;</span>
              {"\n"}  
              <span className="qwerty-5">  c</span>
              <span className="qwerty-4">=</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">+</span>
              <span className="qwerty-5">b</span>
              <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-8">  printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-3">%d </span>
              <span className="qwerty-4">",</span>
              <span className="qwerty-5"> c</span>
              <span className="qwerty-4">);</span>
              {"\n"}
              <span className="qwerty-5">  a</span>
              <span className="qwerty-4">=</span>
              <span className="qwerty-5">b</span>
              <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-5">  b</span>
              <span className="qwerty-4">=</span>
              <span className="qwerty-5">c</span>
              <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-4"> &#125;</span>
              {"\n"}
              <span className="qwerty-7"> return</span>
              <span className="qwerty-3"> 0</span>
              <span className="qwerty-4">; </span>
                  {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div> 
      <h4 className='headings'>Output :</h4>
              <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
                <pre style={{maxHeight:"100vh"}}>
                      <code >                  
                      {"\n"}      
                        <span className="qwerty-10">Fibonacci Series of first 10 number</span>                   
                        {"\n"}         
                        <span className="qwerty-1">0 1 1 2 3 5 8 13 21 34 </span>                   
                        {"\n"}         
                        {"\n"}         
                      </code>
                      </pre>
                      </div> 

<h1 className="mt-5">  </h1>



<div className="back">
        <a href="/c-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cforloop;